import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hospital-mgmt',
  templateUrl: './hospital-mgmt.component.html',
  styleUrls: ['./hospital-mgmt.component.scss']
})
export class HospitalMgmtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
